export class NewsCategory {
  readonly id: number;
  readonly description: string;
}
